import { render, staticRenderFns } from "./redpackage-record-list.vue?vue&type=template&id=664c5e9b&scoped=true&"
import script from "./redpackage-record-list.vue?vue&type=script&lang=js&"
export * from "./redpackage-record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c5e9b",
  null
  
)

export default component.exports